import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from "rxjs/operators";
import {UserStateService} from "@states/user-state.service";
import {Router} from "@angular/router";

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

  constructor(private userStateService: UserStateService, private router: Router) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(
        (response: HttpErrorResponse) => {
          console.log("Response => ", response);

          if (response.status === 401) {
            const url = request.url.toLowerCase();
            const currentRoute = this.router.url.toLowerCase();
            if (url.includes('/api/livedisplay/kiosk') || currentRoute.startsWith('/live-display/kiosk')) {
              return throwError(response);
            }

            localStorage.clear();
            this.userStateService.currentUserSource.next(null);
            this.router.navigate(['/login']);
          }

          return throwError(response);
        }
      )
    );
  }
}
